import ArticlePrice from "../../entities/ArticlePrice";

class ArticleWithPriceResponse {
    public id: string;
    public name: string;
    public description: string;
    public defaultImage: string;
    public prices: ArticlePrice[];
    public amount: number;
    public createdAt: number;
    public physicalAmount?: number;
    public assignedAmount?: number;

    constructor(
        id: string,
        name: string,
        description: string,
        defaultImage: string,
        prices: ArticlePrice[],
        amount: number,
        createdAt: number,
        physicalAmount?: number,
        assignedAmount?: number,
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.defaultImage = defaultImage;
        this.prices = prices;
        this.amount = amount;
        this.createdAt = createdAt;
        this.physicalAmount = physicalAmount;
        this.assignedAmount = assignedAmount;
    }

}

export default ArticleWithPriceResponse;